import React, { useState } from "react";
import "./SearchFilter.css";
import { DropDownList, AutoComplete } from "@progress/kendo-react-dropdowns";
import { Form, Button, InputGroup, Collapse } from "react-bootstrap";
import { GetApplicantName } from "../../apis/OrderAPI";
import * as BsIcons from "react-icons/bs";

export const InvoiceFilter = ({
  search,
  reportTypes,
  requestorid,
  advSearch,
  reportFilterChange,
  displayShort,
  shortFields,
  sortOrder
}) => {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [applicantNames, setApplicantNames] = useState([]);
  const [applicantName, setApplicantName] = useState("");
  const [invoiceStartDate, setInvoiceStartDate] = useState("");
  const [invoiceEndDate, setInvoiceEndDate] = useState("");
  const [isActive, setIsActive] = useState(false);

  const defaultReportType = {
    report_id: "0",
    report_name: "Choose Report....",
  };
  const [reportType, setReportType] = useState(defaultReportType);

  const defaultSort = {
    value: "",
    text: "Order By",
  };
  
  const [sortBy, setSortBy] = useState(defaultSort);

  const getApplicantNames = async (e) => {
    let searchName = e.value;
    setApplicantName(searchName);
    setIsActive(true);
    var investigatorid = "0";
    if (searchName.length > 2) {
      var result = await GetApplicantName({ searchName, requestorid, investigatorid });
      setApplicantNames(result.data);
    }
  };

  const clearFilter = () => {
    setInvoiceStartDate("");
    setInvoiceEndDate("");
    setApplicantName("");
    setReportType(defaultReportType);
    setIsActive(false);
  };

  const handleSearch = (e) => {
    const re = /^[0-9\b]+$/;
    if (e === '' || re.test(e)) {
      setSearchValue(e);
    }
  }

  const handleInvoiceStartDate = (e) => {
    let rstdt = e.target.value;
    if (rstdt !== "") {
      var stdt = new Date(e.target.value);
      if (invoiceEndDate != null && invoiceEndDate !== "") {
        var endt = new Date(invoiceEndDate);
        if (stdt > endt) setInvoiceEndDate(rstdt);
        setInvoiceStartDate(rstdt);
        setIsActive(true);
      } else setInvoiceStartDate(rstdt);
    } else setInvoiceStartDate(rstdt);
  };

  const handleInvoiceEndDate = (e) => {
    let rendt = e.target.value;
    if (rendt !== "") {
      var endt = new Date(e.target.value);
      if (invoiceStartDate != null && invoiceStartDate !== "") {
        var stdt = new Date(invoiceStartDate);
        if (endt < stdt) setInvoiceStartDate(rendt);
        setInvoiceEndDate(rendt);
        setIsActive(true);
      } else setInvoiceEndDate(rendt);
    } else setInvoiceEndDate(rendt);
  };

  return (
    <>
      <div className="filters-option">
        <div className="search-by-filter">
          <InputGroup>
            <Form.Control
              placeholder="Search by order number"
              aria-label="Search by"
              aria-describedby="Search-by"
              value={searchValue}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <Button
              className="search-btn"
              type="button"
              id="Search-by"
              onClick={() => {
                clearFilter();
                search(searchValue);
              }}
            >
              <i className="fa-solid fa-magnifying-glass"></i>
            </Button>
          </InputGroup>
        </div>
        <div className="multi-options-filter">
          <button
            className="btn btn-options-filter"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-controls="example-collapse-text"
          >
            <i className="fa-solid fa-filter"></i>
          </button>
          <Collapse className="filter-box" in={open}>
            <div className="filter-box-inner" id="example-collapse-text">
              <Button
                className="filter-box-close"
                onClick={() => setOpen(!open)}
              >
                <BsIcons.BsXLg />
              </Button>
              <Form className="filter-box-form">
                <Form.Group className="mb-4 row" controlId="CompletionDates">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                     Dates:
                  </Form.Label>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <Form.Control
                      type="date"
                      placeholder="From"
                      value={invoiceStartDate}
                      onChange={handleInvoiceStartDate}
                    />
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <Form.Control
                      type="date"
                      placeholder="To"
                      value={invoiceEndDate}
                      onChange={handleInvoiceEndDate}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-4 row" controlId="ApplicantName">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Applicant Name:
                  </Form.Label>
                  <div className="col-lg-8 col-md-6 col-sm-12">
                    <AutoComplete
                      className="custom-form-control"
                      data={applicantNames}
                      placeholder="e.g. Adam"
                      value={applicantName}
                      onChange={getApplicantNames}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-4 row" controlId="OrderStatus">
                  <Form.Label className="col-lg-4 col-md-6 col-sm-12">
                    Report Type:
                  </Form.Label>
                  <div className="col-lg-8 col-md-6 col-sm-12">
                    <DropDownList
                      className="custom-form-control-select"
                      data={reportTypes}
                      textField="report_name"
                      dataItemKey="report_id"
                      defaultItem={defaultReportType}
                      value={reportType}
                      onChange={(e) => setReportType(e.target.value)}
                      filterable={true}
                      onFilterChange={reportFilterChange}
                    />
                  </div>
                </Form.Group>
                <div className="row">
                  <div className="col-lg-4 col-md-4 col-sm-12"></div>
                  <div className="col-lg-8 col-md-8 col-sm-12">
                    <Button
                      variant="primary"
                      disabled={!isActive}
                      className={isActive ? 'filter-apply-btn' : 'filter-apply-btn-inactive'}
                      type="button"
                      onClick={() => {
                        setSearchValue("");
                        advSearch({
                          invoiceStartDate,
                          invoiceEndDate,
                          applicantName,
                          reportType,
                        });
                        setOpen(!open);
                        clearFilter();
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      className="filter-close-btn"
                      onClick={() => {
                        clearFilter();
                        setOpen(!open);
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </Collapse>
        </div>
        <div className="short-by-filter">
          {/* <Form.Select aria-label="Default select example">
            <option>Sort By</option>
            <option value="1">Sort By Name</option>
            <option value="2">Sort By Order</option>
            <option value="3">Sort By Status</option>
            <option value="3">Sort By Date</option>
          </Form.Select> */}
          <DropDownList
            className="custom-form-control-select sortby-filter"
            data={shortFields}
            textField="text"
            dataItemKey="value"
            defaultItem={defaultSort}
            value={sortBy}
            onChange={(e) => {setSortBy(e.target.value); sortOrder(e.target.value)}}
          />
        </div>
      </div>
    </>
  );
};
